import React from "react";

const SynthesiaVideo = ({ videoData }) => {
  const rawUrl = videoData?.mediaLink?.url;

  if (!rawUrl) return null;

  // Find the UUID inside the URL
  const uuidMatch = rawUrl.match(/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/);

  // If no valid UUID found → do not render anything
  if (!uuidMatch) {
    return null;
  }

  // Extract only the clean ID
  const videoId = uuidMatch[0];

  // Build clean embed URL
  const embedUrl = `https://share.synthesia.io/embeds/videos/${videoId}`;

  return (
    <div className="synthesia-video-container">
      <div >
        <iframe
          src={embedUrl}
          title={videoData.title}
          allow="autoplay; encrypted-media"
          allowFullScreen
          frameBorder="0"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
          }}
        ></iframe>
      </div>
    </div>
  );
};

export default SynthesiaVideo;

